<!-- Simplified file-upload.component.html using Kendo Bootstrap UI classes -->
<div class="form-group" [class.has-error]="showErrorState || !!errorMessage">
  <!-- Label (always rendered for alignment) -->
  <label class="control-label" [attr.for]="inputId">
    <ng-container *ngIf="config.labelText; else emptyLabel">
      {{ config.labelText }}
      <span *ngIf="required" class="text-danger">*</span>
    </ng-container>
    <ng-template #emptyLabel>&nbsp;</ng-template>
  </label>

  <!-- Hidden File Input -->
  <input
    #fileInput
    type="file"
    [accept]="acceptAttribute"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    class="k-hidden"
    [id]="inputId"
  />

  <!-- Image Preview -->
  <div *ngIf="preview && config.showPreview && type === 'image'" class="mb-3">
    <img [src]="preview" alt="Preview" class="img-thumbnail" style="max-width: 200px; max-height: 200px;" />
  </div>

  <!-- Wrapper for input group and drag-drop overlay -->
  <div style="position: relative;">
    <!-- File Display Input Group -->
    <div class="input-group">
    <input
      type="text"
      class="form-control"
      [value]="selectedFile?.name || config.placeholderText"
      [disabled]="disabled"
      readonly
      [placeholder]="config.placeholderText"
    />

    <div class="input-group-btn">
      <!-- Select/Upload Button -->
      <button
        *ngIf="!hasFile"
        type="button"
        kendoButton
        [themeColor]="'dark'"
        [disabled]="disabled"
        (click)="onFileSelectClick()"
      >
        {{ config.selectButtonText }}
      </button>

      <!-- Change Button -->
      <button
        *ngIf="hasFile"
        type="button"
        kendoButton
        [themeColor]="'dark'"
        [disabled]="disabled"
        (click)="onFileSelectClick()"
      >
        {{ config.changeButtonText }}
      </button>

      <!-- Remove Button -->
      <button
        *ngIf="hasFile"
        type="button"
        kendoButton
        [themeColor]="'primary'"
        [disabled]="disabled"
        (click)="removeFile()"
      >
        {{ config.removeButtonText }}
      </button>
    </div>
  </div>

    <!-- Drag and Drop Overlay (only shows when dragging) -->
    <div
      *ngIf="allowDragDrop && isDragOver"
      class="k-overlay"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.95); border: 2px dashed #007bff; z-index: 10;"
    >
      <div class="text-center">
        <kendo-svgicon [icon]="uploadIcon" [size]="'xxxlarge'"></kendo-svgicon>
        <p class="mt-2">Drop your file here</p>
      </div>
    </div>
  </div>

  <!-- Helper Text / File Info -->
  <div class="help-block" *ngIf="showFileInfo && selectedFile && !errorMessage">
    <small class="text-muted">
      Size: {{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB
      <span *ngIf="config.acceptAttribute && config.acceptAttribute !== '*'">
        • Accepted: {{ config.acceptAttribute }}
      </span>
    </small>
  </div>

  <!-- Error Message -->
  <span class="help-block text-danger" *ngIf="combinedErrorMessage">
    {{ combinedErrorMessage }}
  </span>

  <!-- Required Indicator -->
  <span class="help-block text-muted" *ngIf="required && !hasFile && !errorMessage">
    <small>Required field</small>
  </span>

  <!-- Multiple Files List -->
  <div *ngIf="multiple && selectedFiles.length > 1" class="well well-sm mt-2">
    <strong>{{ selectedFiles.length }} files selected</strong>
    <ul class="list-unstyled mb-0 mt-2" *ngIf="showFileInfo" style="max-height: 150px; overflow-y: auto;">
      <li *ngFor="let file of selectedFiles" class="text-muted">
        <small>
          {{ file.name }}
          <span class="text-muted">({{ (file.size / 1024 / 1024).toFixed(2) }} MB)</span>
        </small>
      </li>
    </ul>
  </div>
</div>
